import {
  Directive,
  HostBinding,
  HostListener,
  Output,
  EventEmitter
} from "@angular/core";
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

export class FileHandle {
  file: File;
  type: any;
  size: any;
  url: SafeUrl;
}

@Directive({
    selector: "[appDrag]",
    standalone: false
})
export class DragDirective {
  @Output() files: EventEmitter<FileHandle> = new EventEmitter();

  @HostBinding("style.background")  background = "#fafbf3";

  constructor(private sanitizer: DomSanitizer) { }

  @HostListener("dragover", ["$event"]) public onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = "#dee4b7";
  }

  @HostListener("dragleave", ["$event"]) public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = "#fafbf3";
  }

  @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#fafbf3';

    let uploadedfile = new FileHandle;
    const singleFile = evt.dataTransfer.files[0];
    const fileType = evt.dataTransfer.files[0].type;
    const fileSize = evt.dataTransfer.files[0].size;
    const url = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(singleFile));
    uploadedfile.file = singleFile;
    uploadedfile.url = url;
    uploadedfile.type = fileType;
    uploadedfile.size = fileSize;
    if (uploadedfile !== null) {
      this.files.emit(uploadedfile);
    }
  }
}
